import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Output } from '@angular/core';
import { TabId } from '../tab';
import { TabBodyDirective } from '../tab-body.directive';
import { TabButtonBarDirective } from '../tab-button-bar.directive';

@Component({
  selector: 'avano-tab-item',
  templateUrl: './tab-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabItemComponent {
  @ContentChild(TabBodyDirective) bodyContent!: TabBodyDirective;
  @ContentChild(TabButtonBarDirective) buttonBarContent!: TabButtonBarDirective;

  @Input()
  set tabId(val: TabId) {
    this._tabId = val;
  }
  get tabId(): TabId {
    return this._tabId;
  }

  @Input() label: string;
  @Input() leftIcon: string;
  @Input() closable = false;
  @Input() isLoading = false;
  @Input() isUnsaved = false;

  @Output() readonly closed: EventEmitter<TabId> = new EventEmitter();

  private _tabId: TabId;

  close(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.closed.emit(this._tabId);
  }

  closeFromMenu(): void {
    this.closed.emit(this._tabId);
  }
}
